import * as linkify from "linkifyjs"
export default defineNuxtPlugin((nuxtApp) => {
        // const t = nuxtApp.$i18n.t;

        const validators = {
                required: (value) => !!value || 'This field is required',
                checked: value => !!value || 'This is mandatory',

                password: (value) => {
                    if (value.length < 8) return 'The password must have at least 8 characters'
                    return true;
                },

                confirm: (password) => value => password === value || `Password does not match`,

                email: (value) => (value && linkify.test(value ?? '', "email") || !value) || 'Use a valid e-mail address',
        }

        nuxtApp.provide("valid", validators)
})
